import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { CONTENT } from "@/content";
import { useEnableReveal } from "@/lib/useReveal";
import { Nav } from "@/components/ui/Nav";
import { Footer } from "@/components/ui/Footer";
import { Hero } from "@/components/home/Hero";
import { Authority } from "@/components/home/Authority";
import { Dor } from "@/components/home/Dor";
import { MetodoPreview, TrilhasPreview } from "@/components/home/HomePreviews";
import { Professor } from "@/components/home/Professor";
import { Diagnostico } from "@/components/home/Diagnostico";
import { FAQ } from "@/components/home/FAQ";
import { FloatingShortVideo } from "@/components/ui/FloatingShortVideo";

export default function Home() {
  useEnableReveal();
  const navigate = useNavigate();
  const goFunnel = () => navigate("/agendar/contato");
  const goHome = () => navigate("/");
  const openWhats = () => window.open(CONTENT.brand.whatsappUrl, "_blank", "noopener");

  useEffect(() => {
    const id = sessionStorage.getItem("udi_scroll_to");
    if (!id) return;
    sessionStorage.removeItem("udi_scroll_to");
    window.setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: "smooth" });
    }, 80);
  }, []);

  return (
    <>
      <Nav onCTA={goFunnel} onHome={goHome} />
      <main className="page-enter">
        <Hero onCTA={goFunnel} />
        <Authority />
        <Dor onCTA={goFunnel} />
        <MetodoPreview />
        <TrilhasPreview onCTA={goFunnel} />
        <Professor onCTA={goFunnel} />
        <Diagnostico onCTA={goFunnel} />
        <FAQ onCTA={goFunnel} onWhats={openWhats} />
      </main>
      <FloatingShortVideo videoId="hk-oJgjinA0" title="Apresentação UdiSchool" />
      <Footer onCTA={goFunnel} onHome={goHome} />
    </>
  );
}
